import { render, staticRenderFns } from "./TemplateLayout.vue?vue&type=template&id=6dbf3cc5&"
import script from "./TemplateLayout.vue?vue&type=script&lang=js&"
export * from "./TemplateLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports